import React from 'react';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function Footer() {
  return (
    <>
      <AppBar
        component="footer"
        position="fixed"
        color="primary"
        sx={{ top: 'auto', bottom: 0 }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              textAlign: 'center',
              paddingTop: '10px',
              paddingBottom: '10px',
            }}
          >
            <Typography variant="caption">&copy; 2023 Kei-no-suke</Typography>
          </Box>
        </Container>
      </AppBar>
    </>
  );
}

export default Footer;
